export enum JobStatus {
    FAILED = 'FAILED',
    UPLOADING = 'UPLOADING',
    PROCESSING_LITE = 'PROCESSING_LITE',
    NEW = 'NEW',
    QUEUED = 'QUEUED',
    QUEUED_LITE = 'QUEUED_LITE',
    PROCESSING = 'PROCESSING',
    PROCESSED = 'PROCESSED',
    VIDEO_UPLOADED = 'VIDEO_UPLOADED'
}

export const DWSM_JOB_STATUS_ENUM_LABEL_PREFIX = 'ENUM.DWSM.STATUS.';
